import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuthentication } from "@redux/authentication/hook";

import ForbiddenPage from "@pages/admin/error/forbiddenPage";


export default function ProtectedModuleRoute({ moduleGuid, isAdminOnly }) {
  const { isAuthenticated, moduleAccess, updateIsCurrentModuleAdmin } =
    useAuthentication();
  const location = useLocation();

  useEffect(() => {
    if (moduleAccess?.length > 0)
      updateIsCurrentModuleAdmin(
        moduleAccess?.some((m) => m?.moduleGuid === moduleGuid && m?.isAdmin)
      );
  }, [moduleGuid, moduleAccess]);

  return moduleAccess?.some(
    (m) => m?.moduleGuid === moduleGuid && (isAdminOnly ? m?.isAdmin : true)
  ) ? (
    <Outlet />
  ) : isAuthenticated ? (
    <ForbiddenPage />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace={true} />
  );
}
